module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/GEOGRAPHY-27eb44bc4271410eac4f2c71badbc03a.png";